export class Pricelist {
	id: number;
	pricelist: string;
	description: string;
	country_id: string;
	type: string;
	account_type: string;
	account_status: string;
	classification_id: number;
	main_pricelist: boolean;
	valuta_code: string;
	user_created: string;
	user_modified: string;
	created_at: string;
	updated_at: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/crm/pricelist.ts